import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import type { SkillShort } from '~/shared/data-contract/skill';

import { LearningOpportunitySkillRow } from './LearningOpportunitySkillRow';
import { SkillsEditor } from './SkillsEditor';

export const SkillsColumn: FunctionComponent<{
    readonly isDetectionPending: boolean;
    readonly isEditing: boolean;
    readonly languageCode?: string;
    readonly onSkillClick?: (skillId: string, preferredLanguage?: string) => void;
    readonly onSkillRemoved: (skillId: string) => void;
    readonly skills: readonly SkillShort[];
}> = ({ isDetectionPending, isEditing, languageCode, onSkillClick, onSkillRemoved, skills }) => {
    const translate = useTranslate();

    if (isEditing) {
        return (
            <SkillsEditor
                isDetectionPending={isDetectionPending}
                languageCode={languageCode}
                onSkillClick={onSkillClick}
                onSkillRemoved={onSkillRemoved}
            />
        );
    }

    return (
        <section className="flex flex-col gap-m">
            <h3 className="m-0 text-base font-medium text-black-900">
                {translate('pages.learning-opportunities.trained-skills')}
            </h3>
            {is.nonEmptyArray(skills) ? (
                <div className="flex flex-col gap-xs">
                    {skills.map((skill) => (
                        <LearningOpportunitySkillRow
                            key={skill.id}
                            languageCode={languageCode}
                            skill={skill}
                            onClick={onSkillClick}
                        />
                    ))}
                </div>
            ) : (
                <p className="m-0 text-gray-700 text-sm">{translate('components.skills.no-skills-attached')}</p>
            )}
        </section>
    );
};
